import "./cannot-schedule.scss";
import { cleanNumber } from "../../utility-functions";
import isDesktop from "../../utility-functions/isDesktop";
import SVGInline from "react-svg-inline";
import InfoIcon from "../../assets/info-reviews-drawer.svg";
import { isPrimaryCare } from "../../utility-functions/isPrimaryCare";
import { isOBGYN } from "../../utility-functions/isOBGYN";
import React, { useEffect } from "react";

export const CannotSchedule = (props) => {
    const {
        page,
        clickToCall,
        fetchFailed,
        provider,
        superLocationCardAltLocation,
        superLocationCardAltLocationPhone,
        from,
        onTryDiffLocation,
    } = props;

     useEffect(() => {
        if (window.Invoca && window.Invoca.PNAPI && typeof window.Invoca.PNAPI.run === "function") {
            setTimeout(() => {
                window.Invoca.PNAPI.run();
            }, 100);
        }
    }, [provider, superLocationCardAltLocation, superLocationCardAltLocationPhone]);

    const callToOffice = () => {
        let phoneNumber = "";
        if (superLocationCardAltLocation) {
            phoneNumber = superLocationCardAltLocationPhone
                ? superLocationCardAltLocationPhone
                : "";
        } else {
            phoneNumber = provider.phone ? provider.phone : "";
        }
        phoneNumber = phoneNumber ? cleanNumber(phoneNumber) : phoneNumber;
        return ["super-results", "super-results-alt"].includes(page) &&
            phoneNumber ? (
            <a href={`tel:${phoneNumber}`} onClick={() => clickToCall()}>
                call their office
            </a>
        ) : (
            "call their office"
        );
    };

    switch (page) {
        case "super-results":
        case "profile-page":
        case "times-drawer":
            return (
                <div>
                    {!superLocationCardAltLocation &&
                        !provider.hasScheduleOnline && (
                            <div className="cannot-schedule">
                                {['provider-profile','card'].includes(from) ? (
                                    <span>
                                        {!isDesktop(window.innerWidth) ? (
                                            <SVGInline
                                                svg={InfoIcon}
                                                className="info-icon"
                                            />
                                        ) : null}
                                        <span className="info-text">
                                            To learn more about scheduling with
                                            this provider, please{" "}
                                            {callToOffice()}.
                                        </span>
                                    </span>
                                ) : fetchFailed ? (
                                    <span className="info-text">
                                        Unable to display appointment times,
                                        please try again later.
                                    </span>
                                ) : (
                                    <span className="info-text">
                                        Online scheduling is currently not
                                        available at this location. Choose
                                        another location or call the office to
                                        schedule. <br></br>
                                        <div style={"margin-top : 20px"}>
                                            <a
                                                href={`tel:${cleanNumber(
                                                    provider.phone
                                                )}`}
                                            >
                                                {provider.phone}
                                            </a>
                                        </div>
                                    </span>
                                )}
                            </div>
                        )}
                    {!isPrimaryCare(provider.specialties) &&
                        !isOBGYN(provider.specialtyIds) &&
                        !superLocationCardAltLocation &&
                        provider.hasScheduleOnline && (
                            <div className="cannot-schedule">
                                <span>
                                    {!isDesktop(window.innerWidth) ? (
                                        <SVGInline
                                            svg={InfoIcon}
                                            className="info-icon"
                                        />
                                    ) : null}
                                    <span className="info-text">
                                        To learn more about scheduling with this
                                        provider, please {callToOffice()}.
                                    </span>
                                </span>
                            </div>
                        )}
                    {!superLocationCardAltLocation &&
                        provider.hasScheduleOnline &&
                        (isPrimaryCare(provider.specialties) ||
                            isOBGYN(provider.specialtyIds)) && (
                            <div className="cannot-schedule">
                                <span>
                                    {!isDesktop(window.innerWidth) ? (
                                        <SVGInline
                                            svg={InfoIcon}
                                            className="info-icon"
                                        />
                                    ) : null}
                                    {provider.addresses.length > 1 ? (
                                        <span className="info-text">
                                            This provider's availability changes
                                            daily — check back for new
                                            appointment times or{" "}
                                            {page == "super-results" && !['provider-profile','provider-drawer'].includes(from) ? (
                                                <span
                                                    className="link-to-showlocs"
                                                    onClick={() => {
                                                        onTryDiffLocation();
                                                    }}
                                                >
                                                    try a different location.
                                                </span>
                                            ) : (
                                                "try a different location."
                                            )}
                                        </span>
                                    ) : (
                                        <span className="info-text">
                                            To learn more about scheduling with
                                            this provider, please{" "}
                                            {callToOffice()}. Note: appointment
                                            availability changes on a daily
                                            basis — check again, as needed, to
                                            confirm open appointment times.
                                        </span>
                                    )}
                                </span>
                            </div>
                        )}
                    {superLocationCardAltLocation && (
                        <div className="cannot-schedule-text ">
                            {isDesktop(window.innerWidth) && (
                                <div>
                                    <p>
                                        Online scheduling is currently not
                                        available at this location. Choose
                                        another location or <br></br>{callToOffice()} to
                                        schedule.
                                    </p>
                                </div>
                            )}

                            {!isDesktop(window.innerWidth) && (
                                <div className="cannot-schedule-text-mobile">
                                    <span>
                                        <SVGInline
                                            svg={InfoIcon}
                                            className="info-icon"
                                        />
                                        <span className="info-text">
                                            Online scheduling is currently not
                                            available at this location. Choose
                                            another location or <br></br>{callToOffice()}.
                                        </span>
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            );
        case "super-results-alt":
            return (
                <div className="cannot-schedule-text ">
                    {isDesktop(window.innerWidth) && (
                        <div>
                            <p>
                                Online scheduling is currently not available at
                                this location. Choose another location or <br></br>{callToOffice()} to schedule.
                            </p>
                        </div>
                    )}

                    {!isDesktop(window.innerWidth) && (
                        <div className="border-top">
                            <div className="cannot-schedule-text-mobile">
                                <span>
                                    <SVGInline
                                        svg={InfoIcon}
                                        className="info-icon"
                                    />
                                    <span className="info-text">
                                        Online scheduling is currently not
                                        available at this location. Choose
                                        another location or <br></br>{callToOffice()}.
                                    </span>
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            );
        default:
            return <div></div>;
    }
};
